import { ReversePlanAlignmentFromPoint } from "./types";

export const reversePlanAlignmentFromPoint: ReversePlanAlignmentFromPoint = ({
  point,
  planAlignment,
}) => {
  const scale = planAlignment.scale;
  const rotationDeg = planAlignment.rotation ?? 0;
  const theta = (rotationDeg * Math.PI) / 180;

  const cosT = Math.cos(theta);
  const sinT = Math.sin(theta);

  // 1. Undo translation
  const translatedX = point.x - planAlignment.offsetX;
  const translatedY = point.y - planAlignment.offsetY;

  // 2. Undo Y flip
  const flippedY = -translatedY;

  // 3. Undo rotation (rotate by -theta)
  const rotatedX = translatedX * cosT + flippedY * sinT;
  const rotatedY = -translatedX * sinT + flippedY * cosT;

  // 4. Undo scale
  return {
    x: rotatedX / scale,
    y: rotatedY / scale,
  };
};
